import React from 'react';
import "./Terms.css"; // ✅ add this

const Terms = () => {
  return (
    <div className="terms-container">
      <div className="terms-card shadow-lg">
        <h2 className="terms-title text-center mb-3">Terms & Conditions</h2>
        <div className="underline"></div>

        <p>
          Welcome to <strong>eSevaLinks</strong>. By accessing or using our website, you agree to
          comply with and be bound by the following terms and conditions.
        </p>

        <h5>1. Use of Information</h5>
        <p>
          The information provided on eSevaLinks is for general awareness and educational purposes.
          While we strive to ensure accuracy, we are not responsible for any discrepancies or outdated
          content.
        </p>

        <h5>2. External Links</h5>
        <p>
          Our website may include links to third-party government or service websites. We are not
          responsible for the content, security, or privacy practices of these external sites.
        </p>

        <h5>3. User Responsibility</h5>
        <p>
          You agree to use the platform lawfully and refrain from submitting false or misleading
          information.
        </p>

        <h5>4. Modifications</h5>
        <p>
          eSevaLinks reserves the right to modify or discontinue any aspect of the site at any time
          without prior notice.
        </p>

        <h5>5. Contact</h5>
        <p>
          For any questions regarding these Terms, please contact us through our Contact page.
        </p>
      </div>
    </div>
  );
};

export default Terms;
